const routePerfil = [
    {
        path: '/mi-perfil/:id?',
        name: 'editar-perfil',
        component: () => import(/* webpackChunkName: "mis-postulaciones" */ './editarPerfil.vue'),
        meta: { requiresAuth: true } // Esta ruta requiere autenticación
    }
]

export default routePerfil;